import React, { Component } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import centerOhlIcon from '../images/centerOHL24.png';
import searchIcon1 from '../images/search_01_24.png';
import searchIcon3 from '../images/search_03_24.png';

class PolesList extends Component {

    state = {
        filterText: ''
    }

    filterChange = (e) => {

        this.setState({
            filterText: e.target.value
        });

        if(e.target.value && e.target.value.length > 3){
            //console.log('moze')
        }
    }

    render() {

        let polesElementList = this.props.polesList.map((pole, index) => (
            <ListItem button key={index} name={pole.name}>
                <ListItemText primary={String(index + 1) + '.  ' + pole.name} />
                <span  onClick={() => this.props.onZoomPole(pole.index, {lat: pole.lat, lng: pole.lng}, 2)} style={{marginLeft: '10px', cursor: 'pointer'}}>
                    <img src={searchIcon1} title='Zoom pole (level 2)' alt='Zoom pole (level 2)'/>
                </span>
                <span  onClick={() => this.props.onZoomPole(pole.index, {lat: pole.lat, lng: pole.lng}, 3)} style={{marginLeft: '10px', cursor: 'pointer'}}>
                    <img src={searchIcon3} title='Zoom pole (level 3)' alt='Zoom pole (level 3)'/>
                </span>
            </ListItem>))


        if(this.state.filterText.length > 1){
            polesElementList = polesElementList.filter(element => element.props.name.includes(this.state.filterText));
        }

        return (
            <div style={{margin: '10px'}}>
                {this.props.polesList && this.props.polesList.length > 0 ? 
                <div >
                    <h2> Poles </h2> 
                    <h5> OHL: {this.props.selectedOHL.name}</h5>
                    <h5> Number of poles: {this.props.polesList.length}</h5> 
                    <input type="text" className="input" placeholder="Search..." style={{marginLeft: '10px', width: '65%'}} value={this.state.filterText} onChange={this.filterChange} />
                    <span style={{marginLeft: '20px', cursor: 'pointer'}} onClick={() => this.props.centerOHL(this.props.selectedOHL.name)} >
                        <img src={centerOhlIcon} title='Center OHL' alt='Center OHL'/> 
                    </span>
                </div>
                : null }
                <List>
                    {polesElementList}
                </List>
            </div>
        )
    }
}


export default PolesList;

